import { faFilter } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box } from '@mui/material';

const TableFilterSelect = (props: TableFilterSelectProps) => {
  return (
    <Box
      sx={{
        border: `1px solid #9aa0ae`,
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        borderRadius: 2,
        padding: '0.2rem 0.75rem',
        cursor: 'pointer',
      }}
      onClick={props.onOpen}
    >
      <FontAwesomeIcon icon={faFilter} style={{ fontSize: '1.25rem' }} />

      <Box>0 Filters</Box>
    </Box>
  );
};

export default TableFilterSelect;

type TableFilterSelectProps = {
  onOpen: () => void;
};
